import { render } from "./AuditTrail.vue?vue&type=template&id=50d228d1"
import script from "./AuditTrail.vue?vue&type=script&lang=js"
export * from "./AuditTrail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__